<template>
  <div>
    <table class="table bins-basic-info-table" style="background:transparent;display:block">
      <thead style="color: #eee">
            <tr>
              <th scope="col" style="width: 20%"></th>
              <th scope="col" style="width: 80%"></th>
            </tr>
      </thead>
      <tbody>
          <tr>
                <td class="key-div">{{$t('Protocol type')}}
                  <template v-if="strategyIndex == 0"> *</template>
                </td>
                    <td id="field_protocol" class="value-div d-flex m-0">
                        <!-- <select id="protocol_value" @change="onChange($event)" class="rounded text-light comm-input-field-style">
                            <option value=""></option>
                            <option v-for="(item , index) in protocolList" v-bind:key="index">{{item}}
                            </option>
                        </select> -->
                        <Multiselect
                          id="protocol_value"
                          :value="protocolDetails"
                          :options="protocolList"
                          :searchable="false"
                          :close-on-select="true"
                          :allow-empty="false"
                          deselectLabel=""
                          selectLabel=""
                          selectedLabel=""
                          :placeholder="$t('Select Protocol type')"
                          track-by="_id"
                          @select="onChange($event)"
                          label="label">
                          <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                          <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                          </div>
                          <span slot="noResult">No results.</span>
                        </Multiselect>
                    </td>
          </tr>
          <tr v-if="selectedProtocol == 'file'">
                        <td class="key-div">{{$t('Path')}} *</td>
                        <td id="field_path" class="value-div d-flex m-0">
                            <input id="path_value" type="text" :placeholder="$t('Enter path')" v-model="binCredentials.path" class="rounded text-light comm-input-field-style"/>
                         </td>
          </tr>
          <tr v-if="['ftp','smb'].includes(selectedProtocol)">
                        <td class="key-div">{{$t('IP')}} *</td>
                        <td id="field_server" class="value-div d-flex m-0">
                            <div style="display: grid" class="w-100">
                               <input id="server_value" placeholder="Enter IP address" type="text" @input="ipAddressValidationCheck" v-model="binCredentials.server" class="rounded text-light comm-input-field-style"/>
                               <span v-show="!validIp" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                            </div>
                        </td>
          </tr>
          <tr v-if="['ftp','smb'].includes(selectedProtocol)">
                        <td class="key-div">{{$t('Backup IP')}}</td>
                        <td  id="field_backup_server" class="value-div d-flex m-0">
                           <div style="display: grid" class="w-100">
                               <input id="backup_server_value" type="text" placeholder="Enter backup IP address" @input="backupIpAddressValidationCheck" v-model="binCredentials.backup_server" class="rounded text-light comm-input-field-style"/>
                               <span v-show="!validBackupIp" class="pl-1 pt-1 validationmessage">{{$t('Invalid IP Address')}}</span>
                           </div>
                        </td>
          </tr>
          <tr  v-if="selectedProtocol == 'ftp'">
                        <td class="key-div">{{$t('Port')}}</td>
                        <td class="value-div d-flex m-0">
                           <input type="number" v-model.number="binCredentials.port" placeholder="Enter port" class="rounded text-light comm-input-field-style"/>
                        </td>
          </tr>
          <tr v-if="selectedProtocol == 'ftp'">
                        <td class="key-div">{{$t('Offset path')}} *</td>
                        <td id="field_offset_path" class="value-div d-flex m-0">
                           <input type="text" id="offset_path_value" placeholder="Enter Offset path" v-model="binCredentials.offset_path" class="rounded text-light comm-input-field-style"/>
                        </td>
          </tr>
          <tr v-if="selectedProtocol == 'smb'">
                        <td class="key-div">{{$t("Workgroup")}} *</td>
                        <td id="field_workgroup" class="value-div d-flex m-0">
                           <input type="text" id="workgroup_value" placeholder="Enter workgroup" v-model="binCredentials.workgroup" class="rounded text-light comm-input-field-style"/>
                        </td>
          </tr>
          <tr v-if="selectedProtocol == 'smb'">
                        <td class="key-div">{{$t('Remote name')}} *</td>
                        <td id="field_remote_name" class="value-div d-flex m-0">
                           <input type="text" id="remote_name_value" placeholder="Enter remote name" v-model="binCredentials.remote_name" class="rounded text-light comm-input-field-style"/>
                        </td>
          </tr>
          <tr  v-if="selectedProtocol == 'smb'">
                        <td class="key-div">{{$t('Share name')}} *</td>
                        <td id="field_sharename" class="value-div d-flex m-0">
                            <input type="text" id="sharename_value" placeholder="Enter share name" v-model="binCredentials.sharename" class="rounded text-light comm-input-field-style"/>
                        </td>
          </tr>
          <tr  v-if="['ftp','smb'].includes(selectedProtocol)">
                       <td class="key-div">{{$t('Username')}} *</td>
                       <td id="field_username" class="value-div d-flex m-0">
                           <input type="text" id="username_value" placeholder="Enter user name" v-model="binCredentials.username" autocomplete="off" class="rounded text-light comm-input-field-style"/>
                       </td>
          </tr>
          <tr  v-if="['ftp','smb'].includes(selectedProtocol)">
                       <td class="key-div">{{$t('Password')}} *</td>
                       <td id="field_password" class="value-div">
                           <div style="position:relative;">
                                <input :type="verifypasswordFieldType" placeholder="Enter password" v-model="binCredentials.password" id="password_value" autocomplete="off" class="rounded text-light comm-input-field-style"  style="padding-inline-end:4%">
                                <svg width="2em" height="1.5em"  @click="switchPasswordVisibility" type="password" viewBox="0 0 16 16" class="bi bi-eye ml-1" style="position:absolute;inset-inline-end:7px;top:7px" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                   <path fill-rule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"/>
                                   <path fill-rule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                </svg>
                            </div>
                        </td>
          </tr>
          <tr  v-if="['smb'].includes(selectedProtocol)">
            <td class="key-div">{{$t('SMB Version')}}</td>
            <td id="smb-version" class="value-div">
              <div style="position:relative;">
                <input type="text"  @input="smbVersionValidationCheck" v-model="binCredentials.smb_version"
                 id="version_value" autocomplete="off" class="rounded text-light comm-input-field-style"  style="padding-inline-end:4%">
                <span v-show="!validsmbVersion" class="pl-1 pt-1 validationmessage">{{$t('Invalid SMB Version')}}</span>
                <label class="config-desc" style="text-align: start;">{{$t('Default SMB version is 3.1.1')}}</label>
              </div>
            </td>
          </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import Utils from "../../components.utils.js";
import Multiselect from 'vue-multiselect';
export default {
    props:["strategyIndex"],
    data(){
        return{
            selectedProtocol:"",
            protocolDetails:{_id:"", label:""},
            protocolList:[
                {_id:"", label:""},
                {_id:"file",label:"file"},
                {_id:"ftp", label:"ftp"},
                {_id:"smb",label:"smb"},
                {_id:"aws", label:"AWS-S3-Cloud"}],
            binCredentials:{
              workgroup : "WORKGROUP",
              smb_version : "3.1.1"
            },
            validBackupIp:true,
            validsmbVersion: true,
            secondaryValidIp: true,
            validIp:true,
            passwordFieldType: "password",
            verifypasswordFieldType: "password",
            passwordRegex: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/),
            ipAddressRegex: new RegExp(/^(?:(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.){3}(?:1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/),
            smbVersionRegex:new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/),
            domainNameRegex: new RegExp(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/),
        }
    },

    components:{
      "Multiselect":Multiselect
    },
    methods:{
        switchPasswordVisibility(){
           this.verifypasswordFieldType = this.verifypasswordFieldType === 'password' ? 'text' : 'password';
        },
        setFieldFocus(field){
            if(field == 'protocol'){
              document.getElementById("field_protocol").scrollIntoView();
              document.getElementById("protocol_value").focus();
            }else if(field == 'path'){
              document.getElementById("field_path").scrollIntoView();
              document.getElementById("path_value").focus();
            }else if(field == 'server'){
              document.getElementById("field_server").scrollIntoView();
              document.getElementById("server_value").focus();
            }else if(field == 'backup_server'){
              document.getElementById("field_backup_server").scrollIntoView();
              document.getElementById("backup_server_value").focus();
            }else if(field == 'username'){
              document.getElementById("field_username").scrollIntoView();
              document.getElementById("username_value").focus();
            }else if(field == 'password'){
              document.getElementById("field_password").scrollIntoView();
              document.getElementById("password_value").focus();
            }else if(field == 'offset_path'){
              document.getElementById('field_offset_path').scrollIntoView();
              document.getElementById("offset_path_value").focus();
            }else if(field == 'workgroup'){
              document.getElementById('field_workgroup').scrollIntoView();
              document.getElementById("workgroup_value").focus();
            }else if(field == 'sharename'){
              document.getElementById('field_sharename').scrollIntoView();
              document.getElementById("sharename_value").focus();
            }else if(field == 'remote_name'){
              document.getElementById('field_remote_name').scrollIntoView();
              document.getElementById("remote_name_value").focus();
            }
        },
        getBinDetails(){
            let shareInfo = {}
            if(this.selectedProtocol == "file" && typeof this.binCredentials.path != "undefined"){
                shareInfo["path"] = this.binCredentials.path
                shareInfo["enabled"] = true
            }
            else if(this.selectedProtocol == "ftp" || this.selectedProtocol == "smb"){
                shareInfo["server"] = this.binCredentials.server
                shareInfo["backup_server"] = this.binCredentials.backup_server
                shareInfo["username"] = this.binCredentials.username
                shareInfo["password"] = this.binCredentials.password
                if(this.selectedProtocol == "ftp"){
                    shareInfo["port"] = this.binCredentials.port
                    if(typeof(this.binCredentials.port) == "undefined"){
                      shareInfo["port"] = 21
                    }
                    shareInfo["offset_path"] = this.binCredentials.offset_path
                }else{
                  shareInfo["remote_name"] = this.binCredentials.remote_name
                    shareInfo["workgroup"] =this.binCredentials.workgroup
                    shareInfo["sharename"] = this.binCredentials.sharename
                    if(this.binCredentials.smb_version){
                      shareInfo["smb_version"] = this.binCredentials.smb_version
                    }else{
                      shareInfo["smb_version"] = "3.1.1"
                    }
                }
                shareInfo["enabled"] = true
            }
            return shareInfo
        },
        getSlectedProtocol(){
            return this.selectedProtocol
        },
        ipAddressValidationCheck(){
          if (this.ipAddressRegex.exec(this.binCredentials.server) != null){
            this.validIp = true;
          }else if(this.domainNameRegex.exec(this.binCredentials.server) != null){
            this.validIp = true;
          } else {
            this.validIp = false;
          }
        },
        backupIpAddressValidationCheck(){
          if (this.ipAddressRegex.exec(this.binCredentials.backup_server) != null){
            this.validBackupIp = true;
          }else if(this.domainNameRegex.exec(this.binCredentials.backup_server) != null){
            this.validBackupIp = true;
          } else {
            this.validBackupIp = false;
          }
        },
        smbVersionValidationCheck(){
          if (this.smbVersionRegex.exec(this.binCredentials.smb_version) != null){
            this.validsmbVersion = true;
          } else {
            this.validsmbVersion = false;
          }
        },
        onChange(option){
          this.protocolDetails = option;
          this.selectedProtocol = option._id;
        },
        getBinProtocolTypes(){
            if(Utils.getSupportedBinProtocols().length > 0){
                this.protocolList = Utils.getSupportedBinProtocols;
            }
        }
        // mounted(){
        //     this.getBinProtocolTypes();
        // }
    }
}    
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
svg{
  color:$dull-text-color;
}

svg:hover{
  color:$text-color;
}

h6 {
   width: 100%; 
   text-align: center; 
   border-bottom: 1px solid $danger-color; 
   line-height: 0.1em;
   margin: 10px 0 20px; 
} 

.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}


h6 span { 
    background:$text-color; 
    padding:0 10px; 
}

// .bins-basic-info-table{
//   font-size: 15px;
//   margin-inline-start: 9% !important;
//   tbody {
//     margin: 10px;
//     .key-div {
//       text-align: end;
//       color: $dull-text-color;
//     }
//     .value-div {
//       text-align: start;
//       margin-inline-start: 10px;
//       width: 73%;
//     }
//   }
// }

.config-desc{
  color: $dull-text-color;
}

.bins-basic-info-table{
  display: inline-block;
  widows: 100%;
  font-size: 15px;
  thead{
    display: inline-block;
    width:100%;
  }
  tbody {
    width:100%;
    display: inline-block;
    margin: 0px !important;
    tr{
      width: 100%;
      display: inline-block;
      td.key-div {
        text-align: end;
        color: $dull-text-color;
        width:20%;
        display: inline-block;
        float: inline-start;
      }
      td.value-div {
        text-align: start;
        margin-inline-start: 10px;
        width:30%;
        display: inline-block;
        margin:0px !important;
        float: inline-start;
        div{
          width:100% !important;
        }
        // padding-inline-end: 0px !important
      }
    }  
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}
.activeclass {
  color: $active-blue;
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: none !important;
      border-bottom: none !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: none !important;
    }
  }
}

table.bins-basic-info-table .editIcon {
  visibility: hidden;
}
table.bins-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.custom-control-label::before {
  background-color: $primary-background;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
.validationmessage{
  color:$danger-color;
  font-size: 11px;
}

.primary-btn-style {
  margin-top: 2px;
  button {
    height: 35px;
    width: 70px;
    position: relative;
    float: inline-start;
    inset-inline-start:20%;
    font-size:14px;
  }
}

::v-deep{
  .multiselect{
        width:100% !important;
  }
  .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background;
        border: $border-color;
    }
    .multiselect__option--highlight {
        background: $bg-color-on-hover !important;
    }
    .multiselect__content {
        background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color: $text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: $input-field-and-label-font-size !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width:70%;
      // margin: 0 auto;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
            border: $border-color !important;
            display: block;
            background: $secondary-background-color;
            width: 100%;
            max-height: initial !important;
            overflow: auto;
            border: $border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color!important;
    }
    .multiselect__tags {
        background: transparent !important;
    }
} 


</style>